<template>
  <v-app id="inspire">
     <!-- v-bind:class="isMobileMode?'mobile':'desktop'" -->
    <v-navigation-drawer v-if="!isMobileMode"  class="desktop" app clipped permanent disable-resize-watcher>
      <v-sheet color="blue-grey lighten-5 white--text">
        <v-list>
          <v-list-item class="px-4">
            <v-list-item-avatar>
              <v-avatar color="blue" size="48">
                <span
                  class="white--text"
                  v-if="session.account[0]"
                >{{ JSON.parse(session.account[0].info).company.length >2? JSON.parse(session.account[0].info).company.substr(0,2): JSON.parse(session.account[0].info).company }}</span>
              </v-avatar>
            </v-list-item-avatar>

            <v-list-item-content v-if="session.account[0]">
              <v-list-item-title class="body-1">
                <b>{{JSON.parse(session.account[0].info).company}}</b>
              </v-list-item-title>
              <v-list-item-subtitle
                class="body-2"
                style="margin-top:5px;"
              >{{session.account[0].username}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-sheet>  

      <v-sheet class="px-1 pr-1" light color="grey lighten-4 black--text" height="70">
          <v-row class="inversesearch">
            <v-col>
              <v-autocomplete
                class="pt-3 px-2" 
                v-model="search"
                :items="drpObjectsOnly"
                color="black--text"
                dense
                outlined
                item-text="name"
                item-value="imei"
                label="Search"  
                @change="applySearch(search);"
                prepend-inner-icon="mdi-magnify"
              ></v-autocomplete>
            </v-col>
          </v-row> 
      </v-sheet>  

      <v-list>
        <v-list-group
          v-for="item in asset_groups"
          :key="item.key"
          v-model="item.model" 
          active-class="red--text"
          @click="onGroupClick(item)"
          :ripple="false"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium text-xs">{{ item.text  }} ({{ item.count }})</v-list-item-title>
            </v-list-item-content>
          </template>
          
          <v-virtual-scroll
            :items="item.children"
            :height="item.children.length>5?500:item.children.length && item.children.length!=1<3?150:item.children.length==1?80:350"
            item-height="70"
          >
          <template v-slot:default="{ item }">
            <v-list-item two-line :key="item.imei"
              @click="handleSelect(item)" 
            >
              <v-list-item-action>
                  <v-checkbox :input-value="checkActiveStatus(item)"></v-checkbox>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>
                  {{ item.plate_number || item.name }}
                </v-list-item-title>

                <v-list-item-subtitle>
                  {{ item.current_loc }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-list-item-action-text>
                  {{ item.loc_valid == 1 ? lastSeen(item) : 'No Data' }}
                </v-list-item-action-text>

                <v-list-item-action-text>
                  {{ item.speed }} KPH
                </v-list-item-action-text>
              </v-list-item-action>
            </v-list-item> 
            <v-divider></v-divider>
            </template>
          </v-virtual-scroll> 
        </v-list-group> 
      </v-list> 

      <template v-slot:append>
        <v-list dense>
          <v-list-item link @click="logout">
            <v-list-item-action>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Sign Out</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer> 

    <CoreAppBar :drpObjectsOnly="drpObjectsOnly" :asset_groups="asset_groups" /> 
    <!-- <AlertStack :alerts="alerts" /> -->
    <AlertStack ref="alertStack" :alerts="alerts"/>
    <CoreView  v-bind:class="isMobileMode?'mobile_content':'desktop_content'"   /> 

    <!-- Mobile / tablet bottom navigation (includes an extra Home item). -->
    <CoreBottomNav />
     
  </v-app>
</template>

<style>
@font-face{font-family:Lato;font-style:normal;font-weight:400;src:local('Lato Regular'),local('Lato-Regular'),url(https://fonts.gstatic.com/s/lato/v13/UyBMtLsHKBKXelqf4x7VRQ.woff2) format('woff2');unicode-range:U+100-24F,U+1E00-1EFF,U+20A0-20AB,U+20AD-20CF,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:Lato;font-style:normal;font-weight:400;src:local('Lato Regular'),local('Lato-Regular'),url(https://fonts.gstatic.com/s/lato/v13/1YwB1sO8YE1Lyjf12WNiUA.woff2) format('woff2');unicode-range:U+0-FF,U+131,U+152-153,U+2C6,U+2DA,U+2DC,U+2000-206F,U+2074,U+20AC,U+2212,U+2215}@font-face{font-family:Lato;font-style:normal;font-weight:700;src:local('Lato Bold'),local('Lato-Bold'),url(https://fonts.gstatic.com/s/lato/v13/ObQr5XYcoH0WBoUxiaYK3_Y6323mHUZFJMgTvxaG2iE.woff2) format('woff2');unicode-range:U+100-24F,U+1E00-1EFF,U+20A0-20AB,U+20AD-20CF,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:Lato;font-style:normal;font-weight:700;src:local('Lato Bold'),local('Lato-Bold'),url(https://fonts.gstatic.com/s/lato/v13/H2DMvhDLycM56KNuAtbJYA.woff2) format('woff2');unicode-range:U+0-FF,U+131,U+152-153,U+2C6,U+2DA,U+2DC,U+2000-206F,U+2074,U+20AC,U+2212,U+2215}a.helpText{outline:0}a.helpText strong{line-height:30px}a.helpText span{z-index:10;padding:14px 20px;margin-top:-30px;margin-left:85px;display:none;width:300px;line-height:16px}a.helpText:hover span{display:block;color:#111;position:absolute;border:1px solid #ffd800;background:#fffaf0}.callout{z-index:20;position:absolute;top:15px;border:0;left:-12px}a.helpText span{border-radius:4px;box-shadow:5px 5px 8px #ccc}.wlt_marker_icon{position:absolute;border-radius:50%;border-style:solid;border-width:6px;width:24px;height:24px;background-color:#fff;-webkit-box-shadow:2px 4px 3px 1px #010101;-moz-box-shadow:2px 4px 3px 1px #010101;box-shadow:2px 4px 3px 1px #010101}.nav_icon{position:relative;border-radius:50%;border-style:solid;border-width:6px;width:24px;height:24px;background-color:#fff;-webkit-box-shadow:2px 4px 3px 1px #010101;-moz-box-shadow:2px 4px 3px 1px #010101;box-shadow:2px 4px 3px 1px #010101}.IgnOn_SpdnotZro{color:#8ba846;border-color:#8ba846}.IgnOn_SpdnotZro::after{border-top-color:#8ba846}.IgnOn_SpdisZro{color:#fbc01f;border-color:#fbc01f}.IgnOn_SpdisZro::after{border-top-color:#fbc01f}.IgnOff{color:grey;border-color:grey;border-top-color:grey}.NoHeaderInfSpdNotZero{color:#8ba846;border-color:#8ba846;border-top-color:#8ba846}.NoHeaderInfSpdZero{color:#fbc01f;border-color:#fbc01f;border-top-color:#fbc01f}.Overspid{color:red;border-color:red}.Overspid::after{border-top-color:red}.offline_icon{color:#d7d7d7;border-color:#d7d7d7}.category-Parked{fill:grey;stroke:grey;background:grey;border-color:grey}.category-Moving{fill:#8ba846;stroke:#8ba846;background:#8ba846;border-color:#8ba846}.category-Overspid{fill:#8ba846;stroke:red;background:red;border-color:red}.category-Idle{fill:#fbc01f;stroke:#fbc01f;background:#fbc01f;border-color:#fbc01f}.category-offline{fill:#d7d7d7;stroke:#d7d7d7;background:#d7d7d7;border-color:#d7d7d7}.mapicon{font-size:40px;-webkit-box-shadow:1px #010101;-moz-box-shadow:1px #010101;box-shadow:1px #010101;display:inline-block}
body {
  font-family: "Open Sans", Arial, Helvetica, sans-serif;
  font-size: 12px;
}
 
.desktop_content{
  margin-left: 90px
}

.mobile_content{
  margin-left: 0  !important;
  padding: 3px !important;
  padding-top: 63px !important;
  padding-bottom: 60px !important;
}

.desktop{
  min-width: 350px !important;
}

.mobile{
  width: 0px !important
}

.asset-list {
  max-height: 100%;
  overflow-y: auto;
}

.scroller {
  height: 300px; /* adjust per UI */
}

.float-right {
  float: right;
}
</style>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import common from "./mixins/common";  
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import { alertBus } from '@/plugins/alertBus'
import AlertStack from "./components/AlertStack.vue";  
import { getGroupedAssets, getWatermark, searchAssets, syncAssets } from "@/services/assetsDb";
import { relativeAge } from "@/views/mixins/kensrin_map";

export default {
  name: "Platform",
  components: {
    CoreAppBar: () => import("./components/AppBar"),
    CoreDrawer: () => import("./components/Drawer"),
    CoreView: () => import("./components/View"),
    CoreBottomNav: () => import("./components/BottomNav"),
    AlertStack
  },
  computed: {
    ...mapState([
      "notification",
      "session", 
      "hideSubMenu",
      "selected_object",
      "selected_group",
      "last_sync_id",
      "events"
    ]),
    ...mapGetters(["isLoggedIn"]),
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      }
    },  
    alerts() {
      return alertBus.alerts;
    },
    model: {
      get() {
        return true;
      },
      set(val) {
        //this.$store.commit("SET_DRAWER", val);
      }
    },
    minidrawer: {
      get() {
        return this.$store.state.hideSubMenu;
      },
      set(val) {
        if (this.$store.state.isMobileMode) {
          this.$store.commit("SET_SUB_DRAWER", val);
        }
      }
    }
  },

  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
    clearTimeout(this.vehiclestimer);
    clearTimeout(this.eventstimer);
    clearInterval(this.agetimer);
  }, 
  mixins: [common],
  created() {
    // this.checkVehicles();
    this.checkEvents();
  },
  async mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true }); 

    this.eventstimer = window.setInterval(() => {  
        this.checkEvents(); 
    }, 60000); //120000

    // 1. Hydrate instantly from the offline cache (works with no network).
    await this.loadCachedAssets();

    // 2. Sync deltas from the server, then keep polling.
    this.checkVehicles();
    this.vehiclestimer = window.setInterval(() => {  
        this.checkVehicles(); 
    }, 60000);

    // "Time since last fix" labels must keep ageing even when the poll returns
    // nothing for an asset (a device that stops reporting is dropped from the
    // delta response, so no re-render would otherwise happen).
    this.agetimer = window.setInterval(() => {
        this.nowMs = Date.now();
    }, 30000);
  },
  methods: {
    ...mapActions([
      "register_vehicles",
      "logout",
      "update_device_loaded",
      "select_object",
      "set_last_event",
      "select_active_group",
      "set_last_sync_date",
      "notify_assets_updated"
    ]),

    onGroupClick(item) {
      this.$store.dispatch("select_object",[]); 
      this.$store.dispatch("select_active_group",item.text); 
    },

    setSubDrawer(drawerState, imei) {
      this.selected.push(imei);
      this.$store.dispatch("select_object", imei);  
      // if (this.isMobileMode) 
      //   this.$store.commit("SET_SUB_DRAWER", drawerState);  
    },

    reroute(menuObj) {
      this.$store.commit("SET_ACTIVE_CLASS", menuObj.title);
      this.$router.push(menuObj.to);
    },

    setDrawer(drawerState) {
      this.$store.commit("SET_DRAWER", drawerState);
      this.$store.commit("SET_MAIN_MENUCLICK", true); 
    },

    onResize() {
      this.isMobileMode = window.innerWidth < 990;
    },

    closealert(){
      this.has_alert = false
    },

    logout() {
      this.$store.dispatch("logout"); 
    },  

    async loadCachedAssets() {
      const userid = this.session.account[0].username;
      const [groups, objects] = await Promise.all([
        getGroupedAssets(userid),
        searchAssets(userid, null)
      ]);
      this.drpObjectsOnly = objects;
      if (groups.length > 0) {
        this.applyGroups(groups);
        this.$store.dispatch("update_device_loaded", true);
      }
    },

    applyGroups(groups) {
      this.asset_groups = groups;
      this.all_assets = groups;
      if (this.selected_group) {
        const current = this.asset_groups.find(g => g.text === this.selected_group);
        if (current) current.model = true;
      } else if (this.asset_groups.length > 0) {
        this.asset_groups[0].model = true;
        this.$store.dispatch("select_active_group", this.asset_groups[0].text);
      }
    },

    checkEvents(){ 
      var lastid = this.$store.state.events.last_event_id; 
      this.http_connect("/get_alerts", { token: this.check_token(), lastid: lastid })
        .then(rp => {
          if (rp.status == 200) { 
            if(rp.data.length>0){ 
              this.alert = rp.data[0]; 
              this.has_alert = true;
              this.$store.dispatch("set_last_event", rp.data);   

              rp.data.map(a=>{ 
                alertBus.$emit('push-alert', {
                  type:     'overspeed',
                  asset:    a.name,
                  imei:     a.imei,
                  location: a.loc,
                  speed:    a.speed,
                  eventId:  a.event_id,
                })
              })  
              if(this.$store.state.playNotifications) { 
                var audio = new Audio("http://tracking.speedgovernors.rw/snd/alarm1.mp3");
                audio.play(); 
              } 
            } 
          }
        })
        .catch(err => {});
    },

    async checkVehicles() { 
      const loggedin = this.$store.state.session.loggedin;
      if(!loggedin) 
        return; 

      // Guard against overlapping polls (slow network / large first load).
      if (this.syncing) 
        return;
      this.syncing = true;

      try {
        const userid = this.session.account[0].username;
        // Watermark is derived from dt_tracker (what the server filters on).
        const watermark = await getWatermark(userid); 

        // The heavy /objects endpoint is served by the Node API; every other
        // endpoint still uses the default (PHP) base URL. Set
        // VUE_APP_NODE_OBJECTS_URL to enable (e.g. http://host:3000/api).
        const nodeBase = process.env.VUE_APP_NODE_TRACKING_URL || process.env.VUE_APP_NODE_OBJECTS_URL;
        const config = nodeBase ? { baseURL: nodeBase } : {};

        const rp = await this.http_connect(
          "/objects",
          { token: this.check_token(), 'last_update': watermark },
          config
        );

        if (rp && rp.status == 200) { 
          this.last_load_complete = true; 
          const body = rp.data || {};
          if (String(body.status || '').toLowerCase() != "fail") { 
            // Accept both the {status,payload} envelope and a bare {objects} body.
            const vlist = (body.payload && body.payload.objects) || body.objects || [];  
            // Upsert into the offline cache and get the refreshed groups back.
            const groups = await syncAssets(userid, vlist, { fullSync: !watermark });
            if (groups.length > 0) {
              this.applyGroups(groups);
              this.drpObjectsOnly = await searchAssets(userid, null);
            }
            // Only now are the assets actually in the cache. Tell live views to
            // re-read it (bumps assets_version), THEN flag the load complete so
            // the map skeleton hides only once the data is really available.
            // (Doing this before syncAssets made the loader vanish on first
            // login before the map had any markers.)
            this.$store.dispatch("notify_assets_updated");
            this.$store.dispatch("update_device_loaded", true);
          }
        } else if(rp && rp.status == 401) {
          this.logout();
        }
      } catch (err) {
        console.error("[checkVehicles] sync failed:", err);
      } finally {
        this.syncing = false;
      }
    },
    
    handleSelect(item) {
      if (item.loc_valid != 1) 
        return;   
      this.selected_local = [...this.selected_object]; // create a local copy to modify
      if(this.isSelected(item)){
        this.selected_local = this.selected_object.filter(c=>c!=item.imei);  
      } else {
        this.selected_local.push(item.imei);
      }  
      
      this.$store.dispatch("select_object", this.selected_local);  
    },  

    checkActiveStatus(item) {  
      if(this.selected_object.length == 0) return ''; 
      return this.selected_object.filter(c=>c==item.imei).length > 0? 'active' : '';
    },

    // Live "last seen" label: never render the server's frozen relative string,
    // which keeps saying "Just now" for an asset the delta poll has dropped.
    lastSeen(asset) {
      return relativeAge(asset, this.nowMs);
    },

    isSelected(item) { 
      if(this.selected_object.length == 0) return false;
      return this.selected_object.filter(c=>c==item.imei).length > 0? true : false;
    }
  },
  props: {
    source: String
  },
  data: () => ({
    asset_groups: [],     // grouped structure for UI  
    all_assets: [],      // flat list for search dropdown 
    drpObjectsOnly: [],     // for search dropdown
    search: "",
    searchingItem: "", 
    dialog: false,
    has_alert: false,
    all_selected:  false,
    activeClass: "maps",
    selected_local: [],
    alert: [],
    isMobileMode: false,
    eventstimer: null,
    vehiclestimer: null, 
    agetimer: null,
    nowMs: Date.now(),
    syncing: false,
    last_load_complete: false,
  }),
  // watch:{
  //   selected_group(newVal) {
  //     console.log("Selected group changed:", newVal);
  //     this.$store.dispatch("selected_group",newVal);
  //   }
  // }
};
</script>